import { useState } from 'react';
import { useNavigate } from 'react-router';
import env from "react-dotenv";
import { Header } from '../components/Header';

function ChangePassword() {
    let navigate = useNavigate();

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    async function handleSubmit() {

        if (newPassword !== newPasswordConfirm) {
            setErrorMessage("Les deux nouveaux mots de passe ne correspondent pas.");
        } else {
            const res = await fetch(env.BACKEND_URL + "/admin/change-password", {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                body: JSON.stringify({
                    oldPassword: oldPassword,
                    newPassword: newPassword
                }),
                credentials: 'include'
            });
    
            if (res.ok)
                navigate("/profile");
            else
                setErrorMessage("Erreur : " + await res.text());
        }
    }

    function handleChangeOldPassword(event) {
        setOldPassword(event.target.value);
    }

    function handleChangeNewPassword(event) {
        setNewPassword(event.target.value);
    }

    function handleChangeNewPasswordConfirm(event) {
        setNewPasswordConfirm(event.target.value);
    }

    function handleProfile() {
        navigate("/profile")
    }

    

    return (
        <div>
            <Header navigate={navigate}></Header>
            
            <div className="login">
                <div className="login-form">
                    <div className="login-error-text">
                        {errorMessage}
                    </div>
                    
                    <div className="login-form-title">
                        ANCIEN MOT DE PASSE
                    </div>
                    <input className="input-field" type="password" value={oldPassword} onChange={handleChangeOldPassword} />

                    <div className="login-form-title">
                        NOUVEAU MOT DE PASSE
                    </div>
                    <input className="input-field" type="password" value={newPassword} onChange={handleChangeNewPassword} />

                    <div className="login-form-title">
                        CONFIRMER MOT DE PASSE
                    </div>
                    <input className="input-field" type="password" value={newPasswordConfirm} onChange={handleChangeNewPasswordConfirm} />

                    <div className="flex">
                        <button className="grey-button-password" onClick={handleProfile}>Annuler</button>
                        <button className="button-password" onClick={handleSubmit}>Enregistrer</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChangePassword;